import React from 'react';
import {Box} from "@mui/material";

export default function FlexBox(props) {
  return <Box display="flex" alignItems="center" {...props} />
}